import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PinEntryGuard = () => {
    const location = useLocation();

    if (location.state?.fromDashboard) {
        // If navigated from dashboard selection, allow access
        return <Outlet />;
    }

    // Otherwise, redirect to the main page
    // This prevents direct access to LoginPage without prior selection
    return <Navigate to="/" state={{ from: location }} replace />;
};

export default PinEntryGuard; 